import React, { Component } from 'react'
import { toast } from 'react-toastify'
import _ from 'lodash'
import { connect } from 'react-redux'
import { convertSearchObjectToBase64 } from 'utils/objToBase64'

import { GetWithNonce } from 'utils/axios-nonce'
import { Get, Post, Put } from 'utils/axios-token'
import Lang from 'Lang/General'

const HOC = (WrappedComponent) => {
  class WithHOC extends Component {
    state = {
      showCreateProgramme: false,
      loading: false,
      programmes: [],
      selectedProgramme: null,
      query: {},

      fairs: [],
      stages: []
    }

    onChangeProgrammeHOC = (key, val) => this.setState({ [key]: val })

    load = param => this.setState({ loading: param })
    requestSuccess = success => toast.success(success)
    requestError = error => toast.error(error)

    getProgramme = (query) => {
      this.setState({ query })

      GetWithNonce(
        `/api/v1/fex/fairs_programmes?query=${convertSearchObjectToBase64(query)}`,
        this.getProgrammeSuccess,
        this.getProgrammeError,
        this.load
      )
    }
    getProgrammeSuccess = payload => this.setState({
      programmes: payload.data
    })
    getProgrammeError = error => this.requestError(error.toString())

    getFairs = () => {
      Get(
        `/api/v1/fex/fairs?query=${convertSearchObjectToBase64({
          page: 1,
          is_paginated: false,
          filter: {
            "client_id": this.props.data.selectCenterReducer.selectedCenter.center.client_id,
            "is_active": true,
          }
        })}`,
        this.getFairsSuccess,
        this.getFairsError,
        this.load
      )
    }
    getFairsSuccess = payload => this.setState({
      fairs: _.map(payload.data, child => ({
        ...child,
        label: child.title,
        value: child.short_title,
        name: child.short_title,
        id: child.id
      }))
    })
    getFairsError = error => this.requestError(error.toString())

    createProgramme = dataToSubmit => {
      Post(
        `/api/v1/fex/fairs_programmes`,
        dataToSubmit,
        this.createProgrammeSuccess,
        this.createProgrammeError,
        this.load
      )
    }
    createProgrammeSuccess = () => {
      this.requestSuccess(Lang['RECORD_CREATE_SUCCESS'][this.props.data.languageReducer.userSettings.admin_panel_language])
      this.setState({
        showCreateProgramme: false,
        query: {
          page: 1,
          is_paginated: true,
          filter: { "user_id": this.props.selectedPortalUsers.id },
        }
      }, () => this.getProgramme(this.state.query))
    }
    createProgrammeError = error => {
      if (error.name) {
        this.requestError(error.name)
      } else {
        this.requestError(error)
      }
    }

    getSelectedProgramme = id => {
      Get(
        `/api/v1/fex/fairs_programmes/${id}`,
        this.getSelectedProgrammeSuccess,
        this.getSelectedProgrammeError,
        this.load
      )
    }
    getSelectedProgrammeSuccess = payload => this.setState({ selectedProgramme: payload, showEditModal: true })
    getSelectedProgrammeError = error => this.requestError(error)

    updateProgramme = (dataToSubmit) => {
      Put(
        `/api/v1/fex/fairs_programmes/${dataToSubmit.id}`,
        dataToSubmit,
        this.updateProgrammeSuccess,
        this.updateProgrammeError,
        this.load
      )
    }
    updateProgrammeSuccess = () => {
      this.requestSuccess(Lang['RECORD_UPDATE_SUCCESS'][this.props.data.languageReducer.userSettings.admin_panel_language])
      this.setState({
        showEditModal: false,
        selectedProgramme: null,
        query: {
          page: 1,
          is_paginated: true,
          filter: { "user_id": this.props.selectedPortalUsers.id },
        }
      }, () => this.getProgramme(this.state.query))
    }
    updateProgrammeError = error => this.requestError(error)

    getStages = () => {
      GetWithNonce(
        `/api/v1/fex/stages?query=${convertSearchObjectToBase64({
          page: 1,
          is_paginated: false,
          filter: {
            "client_id": this.props.data.selectCenterReducer.selectedCenter.center.client_id,
          },
        })}`,
        this.getStagesSuccess,
        this.getStagesError,
        this.load
      )
    }
    getStagesSuccess = payload => {
      let temp = _.filter(payload.data, child => child.status !== 'INACTIVE')

      this.setState({
        stages: _.map(temp, child => ({
          ...child,
          name: child.title[this.props.data.languageReducer.userSettings.admin_panel_language],
          label: child.title[this.props.data.languageReducer.userSettings.admin_panel_language],
          value: child.id,
          id: child.id
        }))
      })
    }
    getStagesError = error => this.requestError(error.toString())

    render = () => {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          onLoadSpeaker={this.state.loading}
          getFairs={this.getFairs}
          getStages={this.getStages}
          getProgramme={this.getProgramme}
          createProgramme={this.createProgramme}
          getSelectedProgramme={this.getSelectedProgramme}
          updateProgramme={this.updateProgramme}
          onChangeProgrammeHOC={this.onChangeProgrammeHOC}
        />
      )
    }
  }
  const mapStateToProps = state => ({ data: state })
  return connect(mapStateToProps)(WithHOC)
}

export default HOC
